import {Routes} from '@angular/router';
import {HpDashboardComponent} from '@hp-dashboard/hp-dashboard.component';
import {HpWelcomeComponent} from '@hp-dashboard/hp-welcome/hp-welcome.component';
import {HpProductsComponent} from '@hp-dashboard/hp-products/hp-products.component';
import {HpProductViewComponent} from '@hp-dashboard/hp-product-view/hp-product-view.component';
import {MyVotesComponent} from '@hp-dashboard/my-votes/my-votes.component';
import {UserRoleRouteGuard, UserType} from '@common/messe-ui-toolkit';
import {HpDashboardRelativeRouteBuilder} from '@util/route-builder';

export const HP_DASHBOARD_ROUTES: Routes = [
  {
    path: '',
    component: HpDashboardComponent,
    data: {allowedUserGroups: UserType.HP},
    canActivate: [UserRoleRouteGuard],
    children: [
      {path: '', pathMatch: 'full', redirectTo: HpDashboardRelativeRouteBuilder.welcome().buildRelative()},
      {path: HpDashboardRelativeRouteBuilder.welcome().buildRelative(), component: HpWelcomeComponent},
      {path: HpDashboardRelativeRouteBuilder.voting().buildRelative(), component: MyVotesComponent},
      {path: HpDashboardRelativeRouteBuilder.products().buildRelative(), component: HpProductsComponent},
      {path: HpDashboardRelativeRouteBuilder.productView(':productId').buildRelative(), component: HpProductViewComponent},
    ],
  },
];
